import * as React from "react";
import { NavLink } from "react-router-dom";
import EventDetailsSection from "../EventSideBarComponents/EventDetailsSection";
import BrandingSection from "../EventSideBarComponents/BrandingSection";
import ItemsPaidSection from "../EventSideBarComponents/ItemsPaidSection";
import RegistrationListSection from "../EventSideBarComponents/RegistrationListSection";
import OnlineRegistrationSection from "../EventSideBarComponents/OnlineRegistrationSection";
import UploadContentSection from "../EventSideBarComponents/UploadContentSection";
import PollsPreviewSection from "../EventSideBarComponents/PollsPreviewSection";

const in_array = require("in_array");

const EventSideBar = (props) => {
  const { t } = props;
  const currentPath = window.location.pathname;

  const {
    event,
    eventStep,
    activeBrandingStep,
    dispatch,
    history,
    event_id,
    editData,
    completed_modules,
    defaultModuleRoute,
    toggle,
    isMenuItemAvailable,
    isParentMenuAvailable,
    isChildMenuItemAvailable,
    getParentMenuSortOrder,
    getParentMenuDisplayNumber,
    onToggle,
  } = props;

  return (
    <div className="app-side-application">
      <div className="btn-return-navigation">
        <NavLink 
          to="/" 
          onClick={() => {
            console.log('EventSideBar - Clearing cached menu hierarchy');
            // Clear cached menu hierarchy when returning to list
            if (props.clearCachedMenuHierarchy) {
              props.clearCachedMenuHierarchy();
              console.log('EventSideBar - Cleared cached menu hierarchy');
            }
          }}
        >
          <i className="material-symbols-outlined">arrow_back</i>
          <p>{t("M_RETURN_TO_LIST")}</p>
        </NavLink>
      </div>
      <ul
        style={{ display: "flex", flexDirection: "column" }}
        className={currentPath.includes("/event/create") ? "create-event" : ""}
      >
        <EventDetailsSection
          event={event}
          eventStep={eventStep}
          dispatch={dispatch}
          t={t}
          event_id={event_id}
          editData={editData}
          isMenuItemAvailable={isMenuItemAvailable}
          isChildMenuItemAvailable={isChildMenuItemAvailable}
          completed_modules={completed_modules}
          in_array={in_array}
          getParentMenuSortOrder={getParentMenuSortOrder}
          getParentMenuDisplayNumber={getParentMenuDisplayNumber}
          isParentMenuAvailable={isParentMenuAvailable}
          menuHierarchy={props.menuHierarchy}
        />

        <BrandingSection
          isParentMenuAvailable={isParentMenuAvailable}
          getParentMenuSortOrder={getParentMenuSortOrder}
          getParentMenuDisplayNumber={getParentMenuDisplayNumber}
          isChildMenuItemAvailable={isChildMenuItemAvailable}
          activeBrandingStep={activeBrandingStep}
          dispatch={dispatch}
          history={history}
          t={t}
          toggle={toggle}
          onToggle={onToggle}
          completed_modules={completed_modules}
          in_array={in_array}
          menuHierarchy={props.menuHierarchy}
        />

        <ItemsPaidSection
          event={event}
          isParentMenuAvailable={isParentMenuAvailable}
          getParentMenuSortOrder={getParentMenuSortOrder}
          getParentMenuDisplayNumber={getParentMenuDisplayNumber}
          isMenuItemAvailable={isMenuItemAvailable}
          completed_modules={completed_modules}
          in_array={in_array}
          t={t}
          menuHierarchy={props.menuHierarchy}
        />

        <RegistrationListSection
          event={event}
          isParentMenuAvailable={isParentMenuAvailable}
          getParentMenuSortOrder={getParentMenuSortOrder}
          getParentMenuDisplayNumber={getParentMenuDisplayNumber}
          isMenuItemAvailable={isMenuItemAvailable}
          t={t}
          menuHierarchy={props.menuHierarchy}
        />

        <OnlineRegistrationSection
          event={event}
          isParentMenuAvailable={isParentMenuAvailable}
          getParentMenuSortOrder={getParentMenuSortOrder}
          getParentMenuDisplayNumber={getParentMenuDisplayNumber}
          isMenuItemAvailable={isMenuItemAvailable}
          completed_modules={completed_modules}
          in_array={in_array}
          t={t}
          currentPath={currentPath}
          menuHierarchy={props.menuHierarchy}
        />

        <UploadContentSection
          defaultModuleRoute={defaultModuleRoute}
          isParentMenuAvailable={isParentMenuAvailable}
          getParentMenuSortOrder={getParentMenuSortOrder}
          getParentMenuDisplayNumber={getParentMenuDisplayNumber}
          isMenuItemAvailable={isMenuItemAvailable}
          event={event}
          completed_modules={completed_modules}
          in_array={in_array}
          t={t}
          currentPath={currentPath}
          menuHierarchy={props.menuHierarchy}
        />

        <PollsPreviewSection
          menuHierarchy={props.menuHierarchy}
          getParentMenuSortOrder={getParentMenuSortOrder}
          getParentMenuDisplayNumber={getParentMenuDisplayNumber}
          isParentMenuAvailable={isParentMenuAvailable}
          completed_modules={completed_modules}
          in_array={in_array}
          t={t}
        />
      </ul>
    </div>
  );
};

export default EventSideBar;
